import React from "react";
import {ZoneList} from "../ZoneList/ZoneList";
import {connect} from "react-redux";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import {getZones} from "../ZoneAction";


export let ManageZoneFilter = ({dialogData, onDialogOpen, zone, ...props}) => {
    return (
        <ZoneList title="Gestionar Zonas"  action={getZones} />
    )
}


const mapDispatchToProps = dispatch => {
    return {
        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
    }
}


const mapStateToProps = (state) => {
    return {zone: state.zone};
}
ManageZoneFilter = connect(mapStateToProps, mapDispatchToProps)(ManageZoneFilter);


